import { FC, useEffect, useMemo, useState } from "react";
import { InputCommonProps } from "./Common";
import styles from "./Slider.module.scss";
import { Select } from "./Select";
import { numberGenerator } from "../../Utilities";

interface SliderProps {
    min: number;
    max: number;
    value: number;
    onChange: (val: number) => void;
    showSelect?: boolean;
    itemDescription?: (n: number) => string;
    innerProps?: React.InputHTMLAttributes<HTMLInputElement & HTMLSelectElement>;
}

export const Slider: FC<SliderProps & InputCommonProps> = (props) => {
    const [innerVal, setInnerVal] = useState<number>(props.value);

    const generatedNumbers = useMemo(() => {
        return numberGenerator(props.min, props.max);
    }, [props.min, props.max]);

    useEffect(() => {
        setInnerVal(props.value);
    }, [props.value]);

    useEffect(() => {
        const debounce = setTimeout(async () => {
            props.onChange(innerVal);
        }, 200);

        return () => clearTimeout(debounce);
    }, [innerVal]);

    const itemDescription = props.itemDescription ?? (n => n.toString());

    return (
        <>
            <div className={styles.wrap} style={{ "--val": innerVal, "--min": props.min, "--max": props.max } as React.CSSProperties}>
                <input type="range" className={styles.range} min={props.min} value={innerVal} max={props.max} onInput={e => setInnerVal(parseInt(e.currentTarget.value))} {...props.innerProps} />
                {(props.showSelect ?? true) && (
                    <>
                        <div className={styles.selectContainer}>
                            <Select
                                id="minAge"
                                items={generatedNumbers}
                                values={n => n.toString()}
                                descriptions={itemDescription}
                                value={innerVal}
                                onChange={e => setInnerVal(parseInt(e.target.value))}
                                {...props.innerProps}
                                validations={{ required: true }}
                            />
                        </div>
                    </>
                )}
            </div>
        </>
    );
};